<template>
<div>
  <PageLoader/>
  <router-view></router-view>
</div>
</template>

<script>
import PageLoader from './views/components/PageLoader'

export default {
  components: { PageLoader},
  name: 'App',
  data(){
return{
}
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
@import url('https://fonts.googleapis.com/css2?family=Assistant:wght@300;400&display=swap');
main{
  font-family: 'Assistant'!important;
}
</style>
